const ImageDirectory = {
  LOGO_SPLASH: require("./intro/logo_splash.png"),
  INTRO_BACKGROUND: require("./intro/intro_background.png"),
  LOGIN_BACKGROUND: require("./intro/login_bg.png"),
  COMMON_ALL_USERS: require("./intro/common_all_users.png"),
  USER_TYPE_PLAYER: require("./intro/player_user_types.png"),
  USER_TYPE_COACH: require("./intro/coach_user_types.png"),
  LOGIN_TEXT: require("./intro/login_text_bg.png"),
  TIP_BACKGROUND: require("./images/tip_background.png"),
  SIGNUP_BACKGROUND: require("./intro/signup_background.png"),
  SURROUNDED_GREEN_MARK: require("./images/surrounded_green_checkmark.jpg"),
  DRAFT_AVT: require("./intro/logo_splash.png"),
  VENUE: require("./images/venue.png"),
  EVENT_CARD_CPT: require("./images/event_card_1.png"),
  EVENT_CARD_OD: require("./images/event_card_2.png"),
  EVENT_CARD_OTHERS: require("./images/event_card_3.png"),
  COMING_SOON: require("./images/coming_soon.png"),
  // eslint-disable-next-line import/extensions
  TYPONG_GIF: require("./icons/typing-animation.json"),
  APP_SHOULD_UPDATE: require("./images/appUpdate.png"),
};
export default ImageDirectory;
